const supportedPaths = [
  "hidden",
  "validation.required",
  "validation.string.enum",
  "validation.boolean.enum",
  "validation.predefined.multilineAddressOptions.fields",
  "view.options",
  "view.countryCode"
];
const fieldPathMapToPlatfomized = {
  hidden: ["hidden"],
  "validation.required": ["inputOptions.required"],
  "validation.string.enum": ["inputOptions.stringOptions.validation.enum"],
  "validation.boolean.enum": ["inputOptions.booleanOptions.validation.enum"],
  "view.options": [
    "inputOptions.stringOptions.radioGroupOptions.options",
    "inputOptions.stringOptions.dropdownOptions.options",
    "inputOptions.arrayOptions.checkboxGroupOptions.options"
  ],
  "view.countryCode": []
};
export {
  fieldPathMapToPlatfomized,
  supportedPaths
};
//# sourceMappingURL=transform-path-to-v2.js.map
